import React, { useEffect, useState } from "react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) setShow(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setShow(false);
    setShowSettings(false);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookie-consent", "rejected");
    setShow(false);
    setShowSettings(false);
  };

  const savePreferences = () => {
    const prefs = {
      essential: true,
      analytics,
      marketing,
    };

    localStorage.setItem("cookie-consent", JSON.stringify(prefs));
    setShow(false);
    setShowSettings(false);
  };

  return (
    <>
      <style>{`
        /* FULL-WIDTH CLEAN STRIP */
        .cookie-strip {
          position: fixed;
          left: 0;
          bottom: 0;
          width: 100%;
          background: #ffffff;
          border-top: 1px solid #ddd;
          padding: 10px 0;
          z-index: 9999;
          animation: slideUp 0.35s ease;
        }

        @keyframes slideUp {
          0% { transform: translateY(100%); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }

        .cookie-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        }

        .cookie-text {
          color: #000;
          font-size: 14px;
          margin: 0;
          font-weight: 500;
        }

        .cookie-btn {
          border: none;
          padding: 7px 16px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          margin-left: 8px;
          transition: 0.2s;
        }

        .cookie-accept {
          background: #005eff;
          color: white;
        }
        .cookie-accept:hover {
          background: #0044cc;
        }

        .cookie-reject {
          background: #eaeaea;
          color: #000;
        }
        .cookie-reject:hover {
          background: #dcdcdc;
        }

        .cookie-manage {
          background: transparent;
          color: #000;
          text-decoration: underline;
        }
        .cookie-manage:hover {
          opacity: 0.7;
        }

        /* SETTINGS POPUP */
        .cookie-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.25);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
        }

        .cookie-settings-box {
          width: 90%;
          max-width: 420px;
          background: #fff;
          padding: 22px;
          border-radius: 14px;
          border: 1px solid #e5e5e5;
          box-shadow: 0 10px 35px rgba(0,0,0,0.20);
          animation: fadeScale 0.3s ease;
        }

        @keyframes fadeScale {
          0% { opacity: 0; transform: scale(0.95); }
          100% { opacity: 1; transform: scale(1); }
        }

        .settings-title {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 15px;
        }

        .setting-item {
          margin-bottom: 12px;
          font-size: 15px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .settings-save {
          width: 100%;
          padding: 10px 0;
          border-radius: 8px;
          background: #005eff;
          color: #fff;
          font-size: 15px;
          font-weight: 600;
          border: none;
          margin-top: 10px;
        }

        .settings-save:hover {
          background: #0044cc;
        }

        @media(max-width: 768px) {
          .cookie-container {
            flex-direction: column;
            gap: 10px;
            text-align: center;
          }
        }
      `}</style>

      {/* MAIN COOKIE BAR */}
      {show && !showSettings && (
        <div className="cookie-strip">
          <div className="container cookie-container">

            <p className="cookie-text">
              We use cookies to enhance site performance and security.
            </p>

            <div>
              <button className="cookie-btn cookie-manage" onClick={() => setShowSettings(true)}>
                Manage
              </button>
              <button className="cookie-btn cookie-reject" onClick={rejectCookies}>
                Reject
              </button>
              <button className="cookie-btn cookie-accept" onClick={acceptCookies}>
                Accept
              </button>
            </div>

          </div>
        </div>
      )}

      {/* SETTINGS POPUP */}
      {showSettings && (
        <div className="cookie-overlay">
          <div className="cookie-settings-box">
            
            <div className="settings-title">Cookie Preferences</div>

            <div className="setting-item">
              <input type="checkbox" checked disabled />
              Essential Cookies (required)
            </div>

            <div className="setting-item">
              <input 
                type="checkbox" 
                checked={analytics} 
                onChange={() => setAnalytics(!analytics)} 
              />
              Analytics Cookies
            </div>

            <div className="setting-item">
              <input 
                type="checkbox" 
                checked={marketing} 
                onChange={() => setMarketing(!marketing)} 
              />
              Marketing Cookies
            </div>

            <button className="settings-save" onClick={savePreferences}>
              Save Preferences
            </button>
          </div>
        </div>
      )}
    </>
  );
}
